module.exports = "<label *ngIf=\"showCaption\" [ngClass]=\"position === 1 ? '' : _captionWidth\">{{\r\n    caption\r\n  }}</label>\r\n  \r\n  <div [ngClass]=\"position === 1 ? '' : _fieldWidth\">\r\n    <input #input\r\n      [disabled]=\"disabled\"\r\n      type=\"text\"\r\n      [maxlength]=\"maxlength\"\r\n      [minlength]=\"minlength\"\r\n      class=\"form-control ixsControl\"\r\n      [(ngModel)]=\"value\"\r\n      (blur)=\"onBlur()\"\r\n      [placeholder]=\"placeholder\"\r\n    />\r\n  </div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ixstextbox/ixstextbox.component.html
// module id = 1055
// module chunks = 22